import debug from 'debug'
const logLevel = process.env.LOG_LEVEL || 'debug'

const LOG_LEVELS = ['debug', 'info', 'warn', 'metric', 'error']

/*
 * The log levels are in order defined above from most verbose to least verbose
 * debug will log absolutely everything
 * info does not show any debug logs, but will show info, warn, metrics, and errors
 * warn will log warnings, metrics, and errors; this will be the default log level
 * metric is the log level used for all things that we record to a dashboard
 * error logs only errors and is the lowest log level
 */

function shouldLog(level) {
  const currentIdx = LOG_LEVELS.indexOf(logLevel)
  const levelIdx = LOG_LEVELS.indexOf(level)
  return levelIdx >= 0 && levelIdx >= currentIdx
}

class Logger {
  constructor(namespace) {
    this.loggerId = Math.random().toString(36).substring(2, 9)
    this.namespace = namespace
    this.stdout = debug(namespace)
    this.stderr = debug(namespace)

    // This actually points this at stdout. By default it goes to stderr.
    this.stdout.log = console.log.bind(console)
  }

  enabled = (level) => shouldLog(level)

  _log(level, ...args) {
    if(this.enabled(level)) {
      const levelUpper = level.toUpperCase();
      this.stdout(`[${this.loggerId}][${levelUpper}]`, ...args)
    }
  }

  debug(...args) {
    this._log('debug', ...args)
  }

  info(...args) {
    this._log('info', ...args)
  }

  warn(...args) {
    this._log('warn', ...args)
  }

  metric(...args) {
    this._log('metric', ...args)
  }

  error(...args) {
    this._log('error', ...args)
  }


}

export default Logger
